import React, { useEffect } from "react";
//import TituloCard from "../../atoms/titles/Titulo";
import "../cards/card.scss";
//import ButtonCardMini from "../../atoms/buttons/ButtonCardMini";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../../resources/img/icono-publicaciones.png";

const ActosCard = () => {
  useEffect(() => { }, []);
  const navigate = useNavigate();
  return (

    <section className="temas">
      <Link to="/listadoactos"
        role="link"
        title="Reconocimiento de Nivel de Carrera"
        aria-label="Reconocimiento de Nivel de Carrera"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            navigate("/listadoactos")
          }
        }}
        tabIndex={0}
      >
        <div className="card-caja-mini temas card m-4 h-auto caja-tramites ">
          <div className="tituloAccesibilidad d-flex align-items-center">
            <img

              alt="Recon. de Nivel de Carrera"
              src={Logo}
            />
            <h3 className="tituloAccesibilidad ms-2">Trámites</h3>
          </div>

          {/* <span className="mx-4">Convocatorias Abiertas para solicitar.</span> */}
          <span className="mx-4 fw-light">Mis trámites.</span>
          {/*<p style={{ marginTop: "auto", textAlign: "right" }}>
       <Link to="/carrera">
          <ButtonCardMini nombre="Acceder" clases="btn-card" />
        </Link>
  </p>*/}

        </div>
      </Link>
    </section>

  );
};
export default ActosCard;
